





















import {Component, Prop} from 'vue-property-decorator';
import PriceInput from './PriceInput.vue';
import {getCurrencySymbol} from '@/utils/utils';

@Component
export default class PriceInputWithCurrency extends PriceInput {
  @Prop({required: true }) public room!: any;
  public get currencySymbol(): string {
    return this.room ? getCurrencySymbol(this.room.currencyCode) : '';
  }
}
